import { getAuth } from 'quartz-auth/app/service';
export const getIsAcceptanceTest = () => {
  return !!window.navigator.webdriver;
};

/* Synchronously reads the authed user's email from quartz-auth.
 * Returns true for @hubspot.com users. In-app equivalent of the public
 * app's getIsHubSpotterSync (which reads the COOKIE_ECHO_USER early request).
 * getAuth() throws "App auth not initialized" when quartz-auth was never bootstrapped
 * (e.g. this in-app module is reached from an unauthenticated public-app render path),
 * so this must not let that throw escape to callers. */
export const getIsHubSpotter = () => {
  let email;
  try {
    var _getAuth;
    email = (_getAuth = getAuth()) === null || _getAuth === void 0 || (_getAuth = _getAuth.user) === null || _getAuth === void 0 ? void 0 : _getAuth.email;
  } catch (_unused) {
    return false;
  }
  return typeof email === 'string' && email.endsWith('@hubspot.com');
};